import genererGuid from '@/services/general/genererGuid';

export default function genererEtatSuiviDevisCommande() {
  return {
    id: genererGuid(),
    etatSuiviId: null,
    date: null,
    isCreate: true,
    selected: false,
  };
}
